import React, { useState } from "react";
import { Chip } from "@mui/material";
import { ArrowUpwardOutlined } from "@mui/icons-material";
import { Entrada, Salida, InOut } from "assets/icons";
import { ESTADO_COLORS, ESTADO_LABEL } from "../utils/estado";
import Tooltip from "@mui/material/Tooltip";

const SVG_ACTION = { E: Entrada, S: Salida, A: InOut };

const HORARIO_CHIP_STYLE = {
  V: { backgroundColor: "#f0fdf4", borderColor: "#86efac", color: "#166534" },
  A: { backgroundColor: "#fffbeb", borderColor: "#fcd34d", color: "#6b5700c6" },
  R: { backgroundColor: "#fef2f2", borderColor: "#fca5a5", color: "#991b1b" },
  B: { backgroundColor: "#f9fafb", borderColor: "#e5e7eb", color: "#374151" },
};

export const EventosCell = ({ eventos }) => {
  const [expanded, setExpanded] = useState(false);

  if (!eventos || eventos.length === 0) return null;

  const limit = 3;
  const showAll = expanded || eventos.length <= limit;
  const visibleEventos = showAll ? eventos : eventos.slice(0, limit);
  const hiddenCount = eventos.length - limit;

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "4px", alignItems: "center", padding: "4px 0" }}>
      {visibleEventos.map((eventoStr, index) => {
        let hora = eventoStr;
        let letra = "";
        const parts = eventoStr.split(" ");

        if (parts.length > 1) {
          letra = parts[parts.length - 1];
          hora = parts.slice(0, parts.length - 1).join(" ");
        } else {
          const match = eventoStr.match(/([a-zA-Z]+)$/);
          if (match) {
            letra = match[1];
            hora = eventoStr.slice(0, -letra.length).trim();
          }
        }

        const SvgIcon = SVG_ACTION[letra];

        return (
          <Chip
            key={index}
            label={hora}
            icon={SvgIcon ? <img src={SvgIcon} alt={letra} style={{ width: 14, height: 14, marginLeft: 4 }} /> : undefined}
            size="small"
            variant="outlined"
            color="primary"
          />
        );
      })}
      {!showAll && hiddenCount > 0 && (
        <Chip
          label={`+${hiddenCount}`}
          size="small"
          variant="filled"
          color="default"
          onClick={(e) => { e.stopPropagation(); setExpanded(true); }}
          style={{ cursor: "pointer", fontWeight: "bold" }}
        />
      )}
      {showAll && eventos.length > limit && (
        <Chip
          label={<ArrowUpwardOutlined style={{ width: "14px", height: "14px" }} />}
          size="small"
          variant="filled"
          color="default"
          onClick={(e) => { e.stopPropagation(); setExpanded(false); }}
          style={{ cursor: "pointer" }}
        />
      )}
    </div>
  );
};

export const EstadoCell = ({ value }) => {
  if (!Array.isArray(value)) return null;

  if (value.length === 0) {
    return (
      <span style={{
        display: "inline-block",
        width: 14,
        height: 14,
        borderRadius: "50%",
        backgroundColor: "transparent",
        border: "2px solid #9ca3af",
        boxSizing: "border-box",
      }} />
    );
  }

  const horarioActivo = [...value].reverse().find(h => h.estado && h.estado !== "B");
  const estado = horarioActivo?.estado ?? "B";
  const color = ESTADO_COLORS[estado] ?? "#9ca3af";
  const label = ESTADO_LABEL[estado] ?? estado;

  return (
    <Tooltip title={label}>
      <span style={{
        display: "inline-block",
        width: 14,
        height: 14,
        borderRadius: "50%",
        backgroundColor: estado === "B" ? "transparent" : color,
        border: estado === "B" ? "2px solid #9ca3af" : "none",
        boxSizing: "border-box",
        cursor: "pointer",
      }} />
    </Tooltip>
  );
};

export const HorariosCell = ({ value }) => {
  if (!value || value.length === 0) return null;

  const esObjeto = typeof value[0] === "object";

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "4px", alignItems: "center" }}>
      {value.map((horario, idx) => {
        const label = esObjeto
          ? `${horario.entrada?.slice(0, 5) ?? "?"} - ${horario.salida?.slice(0, 5) ?? "?"}`
          : horario;

        const estado = esObjeto ? (horario.estado ?? "B") : "B";
        const chipStyle = HORARIO_CHIP_STYLE[estado] ?? HORARIO_CHIP_STYLE.B;

        return (
          <Chip
            key={idx}
            label={label}
            size="small"
            variant="outlined"
            style={{
              // backgroundColor: chipStyle.backgroundColor,
              // borderColor: chipStyle.borderColor,
              backgroundColor: 'transparent',
              borderColor: '#545455',
              // color: chipStyle.color,
              color: '#000',
              fontWeight: 500,
            }}
          />
        );
      })}
    </div>
  );
};